export const inspection = {
  items: "项目",
  models: "匹配车型",
  reportName: "点检模板名称",
  modelsNumber: "匹配车型数",
};
